module.exports = "/_next/static/images/9b46a84afce546e6b4793599d8b14bf2-blog4-xs.png";